import { memo, ReactElement } from 'react';
import AccordionCertification from './accordion-applicant';
import AccordionCertificateType from './accordion-certificate-type';
import DocumentMarriageSearchPage from './document-search/search';
import DocumentVisualization from './document-visualization';
import PrintDocument from './print-document';

interface ActiveStepProps {
  step?: number;
  onBack: () => void;
  onNext: () => void;
}
const ActiveStepComponent = ({ step, onBack, onNext }: ActiveStepProps): ReactElement => {
  switch (step) {
    case 0:
      return <AccordionCertification />;
    case 1:
      return <AccordionCertificateType onBack={onBack} />;
    case 2:
      return <DocumentMarriageSearchPage onBack={onBack} onNext={onNext} />;
    case 3:
      return <DocumentVisualization onBack={onBack} onNext={onNext} />;
    case 4:
      return <PrintDocument onBack={onBack} />;
    default:
      return <></>;
  }
};

ActiveStepComponent.displayName = 'Active step component';

const ActiveStep = memo(ActiveStepComponent) as typeof ActiveStepComponent;

export default ActiveStep;
